module.exports = require("@angular/router");